/*
 * @flow
 */
import axios from 'axios';
import * as globals from '../constants/globals';
import { failureActionFn, makeAsyncAction, startActionFn } from '../utils/async_utils';
import { FETCH_AGGREGATE_FAILURE, FETCH_AGGREGATE_START, FETCH_AGGREGATE_SUCCESS } from '../constants/types';
import type { aggregateRequest, cellAggregateRating } from '../model/aggregate';
import { RATVIEW_CELL_CARRIER_OPTIONS } from '../constants/constants';

// Exported for testing only
export function fillCarriers(carriers: Array<cellAggregateRating> = []): Array<cellAggregateRating> {
  RATVIEW_CELL_CARRIER_OPTIONS.forEach((carrierName) => {
    if (!carriers.some((carrier) => carrier.carrier === carrierName)) {
      carriers.push({
        carrier: carrierName,
        average_rating: 0,
        number_of_ratings: 0,
      });
    }
  });
}

export const fetchAggregateEndpoint = (request: aggregateRequest) =>
  `${globals.API_URL}/aggregate?location_id=${encodeURIComponent(
    request.locationId
  )}&location_type=${encodeURIComponent(request.locationType)}`;

const fetchAggregateApi = (request: aggregateRequest) => () => axios.get(fetchAggregateEndpoint(request));

export const fetchAggregate = makeAsyncAction(
  { startType: FETCH_AGGREGATE_START, successType: FETCH_AGGREGATE_SUCCESS, failureType: FETCH_AGGREGATE_FAILURE },
  fetchAggregateApi,
  false,
  'data',
  {
    success: (dispatch, { payload, type }) => {
      fillCarriers(payload.aggregate_cell_coverage_ratings);
      dispatch({ type, payload });
    },
    failure: failureActionFn,
    start: startActionFn,
  }
);
